import { render, staticRenderFns } from "./LeisureProfileComponent.vue?vue&type=template&id=4d94c284&scoped=true"
import script from "./LeisureProfileComponent.vue?vue&type=script&lang=js"
export * from "./LeisureProfileComponent.vue?vue&type=script&lang=js"
import style0 from "./LeisureProfileComponent.vue?vue&type=style&index=0&id=4d94c284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d94c284",
  null
  
)

export default component.exports